// extracted by mini-css-extract-plugin
module.exports = {"container":"ext-card_container__RE_yD","title":"ext-card_title__ZIeBp","item":"ext-card_item__pFMac"};